"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Bundle_Entry = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Bundle_Link_1 = require("./RTTI_Bundle_Link");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_ResourceList_1 = require("../Union/RTTI_ResourceList");
var RTTI_Bundle_Search_1 = require("./RTTI_Bundle_Search");
var RTTI_Bundle_Request_1 = require("./RTTI_Bundle_Request");
var RTTI_Bundle_Response_1 = require("./RTTI_Bundle_Response");
exports.RTTI_Bundle_Entry = t.recursion('IBundle_Entry', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        link: t.array(RTTI_Bundle_Link_1.RTTI_Bundle_Link),
        fullUrl: RTTI_uri_1.RTTI_uri,
        _fullUrl: RTTI_Element_1.RTTI_Element,
        resource: RTTI_ResourceList_1.RTTI_ResourceList,
        search: RTTI_Bundle_Search_1.RTTI_Bundle_Search,
        request: RTTI_Bundle_Request_1.RTTI_Bundle_Request,
        response: RTTI_Bundle_Response_1.RTTI_Bundle_Response
    });
});
//# sourceMappingURL=RTTI_Bundle_Entry.js.map